import {
  Box,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import DeleteIcon from '@mui/icons-material/Delete'
import { Button } from 'ui/baseComponents'

const EMPTY_BUTTON = { title: '', action: 'link', payload: { url: '' } }

const ButtonsEditor = ({ value, onChange }) => {
  const buttons = value || []

  const handleAdd = () => {
    onChange([...buttons, { ...EMPTY_BUTTON, payload: { url: '' } }])
  }

  const handleRemove = (index) => {
    onChange(buttons.filter((_, i) => i !== index))
  }

  const handleFieldChange = (index, field, val) => {
    onChange(
      buttons.map((btn, i) => {
        if (i !== index) return btn
        if (field === 'url') {
          return { ...btn, payload: { ...btn.payload, url: val } }
        }
        return { ...btn, [field]: val }
      }),
    )
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
      {buttons.map((btn, index) => (
        <Box
          key={index}
          sx={{
            display: 'flex',
            gap: 1,
            alignItems: 'center',
          }}
        >
          <TextField
            size="small"
            label="Title"
            value={btn.title || ''}
            onChange={(e) => handleFieldChange(index, 'title', e.target.value)}
            sx={{ flex: 1 }}
          />
          <FormControl size="small" sx={{ minWidth: 130 }}>
            <InputLabel>Action</InputLabel>
            <Select
              value={btn.action || 'link'}
              label="Action"
              onChange={(e) =>
                handleFieldChange(index, 'action', e.target.value)
              }
              MenuProps={{
                PaperProps: {
                  sx: {
                    '& .MuiList-root': {
                      display: 'flex',
                      flexDirection: 'column',
                    },
                  },
                },
              }}
            >
              <MenuItem value="link">Link</MenuItem>
              <MenuItem value="opt_out">Opt Out</MenuItem>
            </Select>
          </FormControl>
          <TextField
            size="small"
            label="URL"
            value={btn.payload?.url || ''}
            onChange={(e) => handleFieldChange(index, 'url', e.target.value)}
            disabled={btn.action === 'opt_out'}
            sx={{ flex: 1 }}
          />
          <IconButton size="small" onClick={() => handleRemove(index)}>
            <DeleteIcon fontSize="small" />
          </IconButton>
        </Box>
      ))}
      <Button
        type="secondary"
        size="small"
        startIcon={<AddIcon />}
        onClick={handleAdd}
        sx={{ alignSelf: 'flex-start' }}
      >
        Add Button
      </Button>
    </Box>
  )
}

export default ButtonsEditor
